import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { PaginationLimit } from '../../../../components/PaginationLimit';
import SearchableDropdown from '../../../../components/SearchableDropdown';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import AddGateKeeperModal from './AddGateKeeperModal';
import ViewGateKeeperModal from './ViewGateKeeperModal';

const GateKeeperListLayer = () => {
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [viewItem, setViewItem] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [societyFilter, setSocietyFilter] = useState(null);

    // Sample societies for autocomplete
    const societies = [
        { id: 1, name: 'Santosh Society' },
        { id: 2, name: 'Demo Jll' },
        { id: 3, name: 'JLL Test' },
        { id: 4, name: 'Onboarding Society' },
        { id: 5, name: 'Zipgrid Family' },
        { id: 6, name: 'HSS Family' },
        { id: 7, name: 'Haunted Societyyew' },
        { id: 8, name: 'IFCI' },
        { id: 9, name: 'Demo JLL Site' },
    ];

    // Sample gatekeeper data
    const gatekeeperData = [
        { id: 134, login: 'gk_admin01', society: 'Santosh Society', phone: '', issueDate: '1/20/2026', remark: 'Primary gate', status: true },
        { id: 133, login: 'gk_tower02', society: 'Demo Jll', phone: '', issueDate: '1/18/2026', remark: 'Tower B entrance', status: true },
        { id: 132, login: 'gk_main03', society: 'JLL Test', phone: '', issueDate: '1/15/2026', remark: 'Main gate', status: false },
        { id: 131, login: 'gk_west04', society: 'Onboarding Society', phone: '', issueDate: '1/22/2026', remark: 'West side gate', status: true },
        { id: 127, login: 'gk_east05', society: 'Zipgrid Family', phone: '', issueDate: '1/10/2026', remark: 'East entrance', status: true },
        { id: 124, login: 'gk_secure06', society: 'HSS Family', phone: '', issueDate: '1/25/2026', remark: 'Security post', status: true },
        { id: 123, login: 'gk_parking07', society: 'Haunted Societyyew', phone: '', issueDate: '1/12/2026', remark: 'Parking access', status: true },
        { id: 120, login: 'gk_gate08', society: 'IFCI', phone: '', issueDate: '1/08/2026', remark: 'Main entrance', status: true },
        { id: 116, login: 'gk_north09', society: 'Haunted Societyyew', phone: '', issueDate: '1/20/2026', remark: 'North gate', status: false },
        { id: 113, login: 'gk_south10', society: 'Demo JLL Site', phone: '', issueDate: '1/14/2026', remark: 'South entrance', status: true },
    ];

    const handleAddClick = () => {
        setEditItem(null);
        setAddModalOpen(true);
    };

    const handleEditClick = (item) => {
        setEditItem(item);
        setAddModalOpen(true);
    };

    const handleViewClick = (item) => {
        setViewItem(item);
        setViewModalOpen(true);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log('Searching:', searchQuery);
    };

    const handleRefresh = () => {
        setSearchQuery('');
        setStatusFilter('all');
        setSocietyFilter(null);
    };

    return (
        <div className="card">
            {/* Header */}
            <div className="card-body">
                {/* Filters Section */}
                <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                    <div className="d-flex align-items-center gap-2">
                        <Icon icon="mdi:filter-outline" className="text-lg text-secondary-light" />
                        <span className="text-sm fw-medium">Filters:</span>
                    </div>

                    {/* Society Autocomplete */}
                    <Autocomplete
                        size="small"
                        options={societies}
                        getOptionLabel={(option) => option.name}
                        value={societyFilter}
                        onChange={(e, newValue) => setSocietyFilter(newValue)}
                        sx={{ width: 200 }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Community"
                                placeholder="Search community..."
                            />
                        )}
                    />

                    {/* Status Filter */}
                    <div className="tw-w-40">
                        <SearchableDropdown
                            value={statusFilter}
                            onChange={setStatusFilter}
                            options={[
                                { value: 'all', label: 'All Status' },
                                { value: 'active', label: 'Active' },
                                { value: 'inactive', label: 'Inactive' },
                            ]}
                            placeholder="Status"
                            clearable={false}
                            small
                        />
                    </div>

                    {/* Search Form */}
                    <form onSubmit={handleSearch} className="d-flex align-items-center gap-2">
                        <TextField
                            size="small"
                            placeholder="Search login, phone, remark..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" color="action" />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ width: 250 }}
                        />
                        <button type="submit" className="btn btn-sm btn-primary-600">
                            Search
                        </button>
                    </form>

                    <div className="ms-auto d-flex align-items-center gap-2">
                        <button onClick={handleAddClick} className="btn btn-sm btn-primary-600 d-flex align-items-center gap-2">
                            <Icon icon="mdi:plus" className="text-lg" />
                            Add New GateKeeper
                        </button>
                        <Tooltip title="Refresh List" placement="top" arrow>
                            <button onClick={handleRefresh} className="btn btn-sm btn-outline-secondary ">
                                <Icon icon="mdi:refresh" className="text-lg" />
                            </button>
                        </Tooltip>
                    </div>
                </div>

                {/* Table */}
                <table className="table bordered-table mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Sl No.</th>
                            <th scope="col">ID</th>
                            <th scope="col">Login</th>
                            <th scope="col">Community</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Issue Date</th>
                            <th scope="col">Remark</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gatekeeperData.map((gatekeeper, index) => (
                            <tr key={gatekeeper.id}>
                                <td>{index + 1}</td>
                                <td>
                                    <span className="text-primary-600 fw-medium">{gatekeeper.id}</span>
                                </td>
                                <td>
                                    <span className="text-sm fw-medium">{gatekeeper.login}</span>
                                </td>
                                <td>
                                    <div className="text-truncate" style={{ maxWidth: 150 }} title={gatekeeper.society}>
                                        {gatekeeper.society}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center gap-1">
                                        <Icon icon="mdi:phone" className="text-secondary-light" />
                                        <span>{gatekeeper.phone || '-'}</span>
                                    </div>
                                </td>
                                <td>{gatekeeper.issueDate || '-'}</td>
                                <td>
                                    <div className="text-truncate" style={{ maxWidth: 120 }} title={gatekeeper.remark}>
                                        {gatekeeper.remark || '-'}
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center gap-1">
                                        <Switch
                                            checked={gatekeeper.status}
                                            size="small"
                                            color="success"
                                        />
                                        <span className={`text-xs fw-medium ${gatekeeper.status ? 'text-success-main' : 'text-secondary-light'}`}>
                                            {gatekeeper.status ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center gap-1">
                                        <Tooltip title="View Details" placement="top" arrow>
                                            <button
                                                onClick={() => handleViewClick(gatekeeper)}
                                                className="w-32-px h-32-px bg-primary-50 text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                                            >
                                                <Icon icon="mdi:eye" />
                                            </button>
                                        </Tooltip>
                                        <Tooltip title="Edit" placement="top" arrow>
                                            <button
                                                onClick={() => handleEditClick(gatekeeper)}
                                                className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                                            >
                                                <Icon icon="lucide:edit" />
                                            </button>
                                        </Tooltip>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <PaginationLimit totalRecords={10} />
            </div>

            {/* Add/Edit GateKeeper Modal */}
            <AddGateKeeperModal
                open={addModalOpen}
                handleClose={() => { setAddModalOpen(false); setEditItem(null); }}
                editData={editItem}
            />

            {/* View GateKeeper Modal */}
            <ViewGateKeeperModal
                open={viewModalOpen}
                handleClose={() => { setViewModalOpen(false); setViewItem(null); }}
                data={viewItem}
            />
        </div>
    );
};

export default GateKeeperListLayer;
